export function header_init(){
    load_header_sticky();
}

function load_header_sticky(){
    if( ff.disable_header_sticky ) return;
    if( document.body.classList.contains('disable_header_sticky') ) return; 
    document.addEventListener('scroll', load_header_sticky_scripts, {passive: true});
}

function load_header_sticky_scripts(){

    if( window.scrollY < 500 ) return;

    document.removeEventListener('scroll', load_header_sticky_scripts);

    import('./sticky/header_sticky.scss');

    if( ff.header_sticky_disable_auto_hide ) {
        import('./sticky/header_sticky_v2');
    }
    else {
        import('./sticky/header_sticky');
    }
}